import * as React from 'react';
import * as utils from './utils';
import { useTranslation } from 'react-i18next';
const currencyWarning = ({ total }) => {
    const { t } = useTranslation('Checkout');
    const showNote = utils.needShowWarning(total);
    return (showNote && (React.createElement("div", null, t('All payments will be charged in Russian rubles. The amounts indicated in other currencies are presented as a guideline.'))));
};
export default currencyWarning;
